export function init($name = '') {
    const dropdown = $($name);

    if (!dropdown.length) {
        return;
    }

    dropdown.each(function() {
        const parent = $(this);

        parent.find($name + '-click').click(function(e) {
            e.preventDefault();
            e.stopPropagation();

            parent.find($name + '-list').slideDown();
            parent.find($name + '-autocomplete').val('');
            parent.find($name + '-list').children('ul').children().show().children('ul').children().show();
        });

        parent.find($name + '-list').find('li[data-value]').click(function() {
            const value = $(this).attr('data-value');
            const group = $(this).parents('[data-group]').attr('data-group');

            parent.find($name + '-value').val(value.toUpperCase()).parsley().validate();

            if (parent.parents($name + '-parent').length && parent.parents($name + '-parent').find($name + '-parent-zipcode').length) {
                const elem = parent.parents($name + '-parent').find($name + '-parent-zipcode');

                if (group !== 'other') {
                    elem.attr('data-parsley-oxzipcode', group);
                } else {
                    elem.removeAttr('data-parsley-oxzipcode');
                }

                elem.parsley().validate();
            }
        });

        $('body').click(function() {
            parent.find($name + '-list').slideUp();
        });

        parent.find($name + '-autocomplete').click(function(e) {
            e.preventDefault();
            e.stopPropagation();
        });

        parent.find($name + '-autocomplete').on('keyup', function () {
           const elems = parent.find($name + '-list').children('ul').find('ul').children();
           const value = $(this).val();

           if (value === '') {
               parent.find($name + '-list').children('ul').children().show().children('ul').children().show();
               return;
           }

           elems.each(function() {
               $(this).toggle($(this).html().toLowerCase().indexOf(value.toLowerCase()) >= 0);
               $(this).parent().parent().toggle($(this).parent().children(':visible').length !== 0);
           });
        });
    });
}
